import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import UserProfileSuccessModal from './UserProfileSuccessModal';

const clearUserProfileSuccessQueryParam = () => {
	const url = new URL(window.location);
	const params = new URLSearchParams(url.search);

	if (
		params.has('user_profile_success') &&
		params.get('user_profile_success') === 'true'
	) {
		params.delete('user_profile_success');

		const newUrl = params.toString()
			? `${url.pathname}?${params.toString()}`
			: url.pathname;
		window.history.replaceState({}, '', newUrl);
	}
};

export default function AuthenticatedWelcomeModal({
	create_checkout_session_endpoint,
	stripe_public_key,
	stripe_product_essential_id,
	stripe_product_advanced_id,
	stripe_product_ultimate_id
}) {
	const [isOpen, setIsOpen] = useState(false);
	const location = useLocation();
	const { authenticated, loading } = useAuth();

	useEffect(() => {
		if (loading || !authenticated) {
			setIsOpen(false);
			return;
		}

		const params = new URLSearchParams(location.search);
		if (params.get('user_profile_success') === 'true') {
			setIsOpen(true);
		}
	}, [location.search, authenticated, loading]);

	const handleClose = () => {
		setIsOpen(false);
		clearUserProfileSuccessQueryParam();
	};

	return (
		<UserProfileSuccessModal
			isOpen={isOpen}
			onClose={handleClose}
			create_checkout_session_endpoint={create_checkout_session_endpoint}
			stripe_public_key={stripe_public_key}
			stripe_product_essential_id={stripe_product_essential_id}
			stripe_product_advanced_id={stripe_product_advanced_id}
			stripe_product_ultimate_id={stripe_product_ultimate_id}
		/>
	);
}
